<template>
  <div>
    <div v-if="!isOilMeasurement">
      <div class="row" id="switcheventsrow">
        <div class="col s12">
          <div class="row"></div>
          <TimeSelector
            :measurements="allMeasurements"
            :selected="selectedMeasurementIds"
            :activeMeasurement="activeMeasurement"
            :timeFrame="timeFrame"
            :max-date="maxDate"
            :ref-history="refHistory"
            :is-parent="isParent"
            :switchObject="switchObject"
            @on-change-timeframe="changeTimeFrame"
            @on-select="addSelectedMeasurement"
            @on-deselect="removeSelectedMeasurement"
            @on-reset="resetSelectedMeasurements"
            @on-hover-measurement="hoverMeasurement"
            @on-graph-mode-changed="graphModeChanged" />
          <div class="row">
            <div class="col s12">
              <div class="row">
                <div v-if="graphMode==='split'" class="col s9">
                  <div class="z-depth-1 white" style="margin: 5px 0px 0px 0px;" v-for="item in measurementComponents" :key="item.id" v-show="!loading && item.active">
                    <SimpleChart
                      :id="item.id"
                      :measurements="selectedMeasurements.filter(x => x.RailObjectId === item.id)"
                      :measurement-ids="selectedMeasurementIds"
                      :offsets="offsets"
                      :yAxisTitle="item.unitOfMeasure"
                      :title="item.name"
                      :referenceMeasurement="referenceMeasurement"
                      :measurementHover="measurementHover"
                      :event="event"
                      :active-signal="activeSignal"
                      :chartMinX="chartMinX"
                      :chartMaxX="chartMaxX"
                      :chartMinY="chartMinY"
                      :chartMaxY="chartMaxY"
                      :sensors="sensors"
                      @set-max="setMeasurementMax"
                      @on-select-measurement="changeActiveMeasurement" />
                  </div>
                  <div class="z-depth-1 white center-align" style="height: 500px" v-show="loading">
                    <div class="row" style="padding-top: 100px">
                      <div class="preloader-wrapper active">
                      <div class="spinner-layer spinner-white-only">
                        <div class="circle-clipper left">
                          <div class="circle"></div>
                        </div><div class="gap-patch">
                          <div class="circle"></div>
                        </div><div class="circle-clipper right">
                          <div class="circle"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <span>Loading data...</span>
                  </div>
                  </div>
                </div>
                <div v-else class="col s12">
                  <div class="z-depth-1 white" v-show="!loading">
                  <SwitchChart
                    :measurements="selectedMeasurements"
                    :measurement-ids="selectedMeasurementIds"
                    :offsets="offsets"
                    :activeMeasurement="activeMeasurement"
                    :title="chartTitle"
                    :yAxisTitle="yAxisTitle"
                    :referenceMeasurement="referenceMeasurement"
                    :measurementHover="measurementHover"
                    :event="event"
                    :active-signal="activeSignal"
                    :chartMinX="chartMinX"
                    :chartMaxX="chartMaxX"
                    :chartMinY="chartMinY"
                    :chartMaxY="chartMaxY"
                    :sensors="sensors"
                    @set-max="setMeasurementMax"
                    @on-select-measurement="changeActiveMeasurement" />
                  </div>
                  <div class="z-depth-1 white center-align" style="height: 500px" v-show="loading">
                    <div class="row" style="padding-top: 100px">
                      <div class="preloader-wrapper active">
                        <div class="spinner-layer spinner-white-only">
                        <div class="circle-clipper left">
                          <div class="circle"></div>
                        </div><div class="gap-patch">
                          <div class="circle"></div>
                        </div><div class="circle-clipper right">
                          <div class="circle"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <span>Loading data...</span>
                  </div>
                  </div>
                </div>

                <!-- Measurement component selector -->
                <div v-if="graphMode==='split'" class="col s3">
                  <div v-show="!loading && measurementComponents.length > 0" class="col s12 z-depth-1 white" style="min-height: 250px;" >
                    <div class="input-field">
                      <ul class="vertical-list filter-graph-list">
                      <li class="vertical-list-item filter-graph-list-item">
                        <label class="checkbox-small">
                        <input type="checkbox" name="dir_item.id" v-model="selectAllMeasurementComponents" @click="selectAllMeasurementComponentsEvent"/>
                        <span class="checkbox-small body1">{{ $t('views.switch.charts.all') }}</span>
                        </label>
                      </li>
                      <hr/>
                      <li class="vertical-list-item filter-graph-list-item" v-for="item in measurementComponents" :key="item.id">
                        <label class="checkbox-small">
                        <input type="checkbox" name="dir_item.id" v-model="item.active" />
                        <span class="checkbox-small body1">{{ item.name }}</span>
                        </label>
                      </li>
                      </ul>
                    </div>
                    </div>
                    <div class="z-depth-1 white center-align" style="height: 250px;" v-show="loading">
                      <div class="row" style="padding-top: 100px">
                        <div class="preloader-wrapper active">
                          <div class="spinner-layer spinner-white-only">
                            <div class="circle-clipper left">
                              <div class="circle"></div>
                            </div>
                            <div class="gap-patch">
                            <div class="circle"></div>
                          </div>
                          <div class="circle-clipper right">
                            <div class="circle"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <span>Loading data...</span>
                    </div>
                  </div>
                </div>

              </div>
              <div class="row" v-show="!loading" v-if="digitalSignals.length > 0">
                <div class="col" :class="{ s9: graphMode === 'split', s12: graphMode !== 'split'}" >
                  <div class="z-depth-1 white" >
                    <!--digital Signals-->
                    <DigitalSignalGraph
                      :active-measurement="activeMeasurement"
                      :sensors="sensors"
                      :digital-signals="digitalSignals"
                      :active-signal="activeSignal"
                      :chart-max="chartMaxX"
                      :min-date="minMeasurementDateTime"
                      @set-max="setDigitalMax"
                      @hover-signal="hoverSignal" />
                  </div>
                </div>
              </div>
              <div class="z-depth-1 white center-align" style="height: 500px" v-show="loading">
                <div class="row" style="padding-top: 100px">
                  <div class="preloader-wrapper active">
                    <div class="spinner-layer spinner-white-only">
                      <div class="circle-clipper left">
                        <div class="circle"></div>
                      </div>
                      <div class="gap-patch">
                        <div class="circle"></div>
                      </div>
                      <div class="circle-clipper right">
                        <div class="circle"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <span>Loading data...</span>
                </div>
              </div>
              <div class="row">
                <div class="col s12">
                  <div class="z-depth-1 white">
                    <EventDetails
                      :measurement-events="measurementEvents"
                      :event="event"
                      @on-select="selectEvent" />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col s12">
                  <div class="z-depth-1 white">
                    <MeasurementComments  v-show="!loading"
                      :switch-object="switchObject"
                      :active-Measurement="activeMeasurement"
                      :lastselectedMeasurement="lastSelectedMeasurement"
                      :selectedMeasurementIds="selectedMeasurementIds"
                      @comment-added="onCommentAdded"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isOilMeasurement">
      <div class="row"></div>
      <div class="row">
        <OilDigital
          :switchObject="switchObject">
          </OilDigital>
      </div>
    </div>
  </div>
</template>

<script>
import TimeSelector from '../../components/switch/TimeSelector'
import SwitchChart from '../../components/switch/Chart'
import SimpleChart from '../../components/switch/SimpleChart'
import OilDigital from '../../components/switch/OilDigital'
import EventDetails from '../../components/switch/EventDetails'
import measurementsApi from '../../services/api/switch/MeasurementsApi'
import RailObjectService from '../../services/RailObjectService'
import DigitalSignalGraph from '../../components/switch/DigitalSignalGraph'
import moment from 'moment'
import MeasurementComments from '../../components/switch/MeasurementComments'
import AlarmService from '../../services/AlarmService'
import _ from 'lodash'
import Router from '../../router'

export default {
  name: 'SwitchEvents',
  props: {
    sensorData: Array,
    switchObject: {
      type: Object,
      default: () => {
        return {
          MeasurementSet: {
            TriggeredMeasurements: []
          }
        }
      }
    },
    measurementId: {
      type: Number,
      default: null
    },
    title: {
      required: true
    }
  },
  components: {
    OilDigital,
    TimeSelector,
    SwitchChart,
    SimpleChart,
    EventDetails,
    DigitalSignalGraph,
    MeasurementComments
  },
  async created () {
    this.checkIfOilDigital()
    if (this.switchObject.RailObjectId) {
      await this.loadData()
    }
  },
  data () {
    return {
      loading: false,
      changeTimeFrameGuard: moment(),
      getMeasurementsRequestId: 0,
      sensors: [],
      isOilMeasurement: false,
      allMeasurements: [],
      timeFrame: {
        start: moment().subtract(1, 'w'),
        end: moment()
      },
      allTemperatures: [],
      selectedMeasurementIds: [],
      selectedMeasurements: [],
      activeMeasurement: null,
      lastSelectedMeasurement: null,
      measurementEvents: [],
      chartMinX: 0,
      chartMaxX: 0,
      chartMinY: null,
      chartMaxY: null,
      yAxisTitle: '',
      measurementMax: 0,
      digitalMax: 0,
      digitalSignals: [],
      referenceMeasurement: null,
      refHistory: [],
      measurementHover: null,
      event: null,
      activeSignal: null,
      measurementComponents: [],
      selectAllMeasurementComponents: true,
      graphMode: localStorage.graphMode,
      currentId: null
    }
  },
  computed: {
    minMeasurementDateTime () {
      let val = this.selectedMeasurements.map(s => s.MeasurementDateTime).reduce(function (a, b) { return a < b ? a : b })
      return val
    },
    isParent () {
      return this.switchObject.ParentRailObjectId === null
    },
    chartTitle () {
      return this.switchObject ? this.title + this.switchObject.Name : ''
    },
    offsets () {
      let result = {}
      this.selectedMeasurementIds.forEach(m => {
        if (!result[m.railObjectId]) {
          result[m.railObjectId] = {}
        }
        let set = []
        m.children.forEach(c => {
          set.push(c.dateTime)
        })
        if (set.length > 0) {
          let min = moment('2099-11-28T15:41:59.139901')
          set.push(m.dateTime)
          min = set.reduce(function (a, b) { return a < b ? a : b })
          m.children.forEach(c => {
            if (!result[c.railObjectId]) {
              result[c.railObjectId] = {}
            }
            result[c.railObjectId][c.id] = moment(c.dateTime).diff(moment(min), 'millisecond', true)
          })
          result[m.railObjectId][m.id] = moment(m.dateTime).diff(moment(min), 'millisecond', true)
        } else {
          if (!result[m.railObjectId] || (result[m.railObjectId] && !result[m.railObjectId][m.id])) {
            result[m.railObjectId][m.id] = 0
          }
        }
      })
      return result
    },
    maxDate () {
      if (this.switchObject && this.switchObject.MeasurementSet.TriggeredMeasurements[0]) {
        let maxDate = this.$options.filters.correctedMomentDate(this.switchObject.MeasurementSet.TriggeredMeasurements[this.switchObject.MeasurementSet.TriggeredMeasurements.length - 1].MeasurementDateTime).toDate()
        return maxDate
      } else {
        return new Date()
      }
    },
    currentQueryMeasurementId () {
      const mid = this.$route.query.measurementId
      return mid && !isNaN(mid) ? Number(mid) : null
    }
  },
  watch: {
    chartTitle () {
      this.checkIfOilDigital()
    },
    switchObject (newVal, oldVal) {
      // Only reload data if RailObjectId changes
      if (newVal && oldVal && newVal.RailObjectId !== oldVal.RailObjectId) {
        this.loadData()
      }
    },
    selectedMeasurementIds () {
      this.setMeasurementIds()
    },
    selectedMeasurements () {
      if (this.selectedMeasurements.length === 1) {
        this.activeMeasurement = this.selectedMeasurements[0]
      } else if (this.selectedMeasurements.length === 0) {
        this.activeMeasurement = null
      } else if (this.activeMeasurement && this.activeMeasurement.MeasurementId !== null && this.selectedMeasurements.findIndex(s => s.id === this.activeMeasurement.MeasurementId) === -1) {
        this.activeMeasurement = this.selectedMeasurements[0]
      } else {
        // keep current activeMeasurement
        this.activeMeasurement = this.selectedMeasurements[0]
      }
    },
    activeMeasurement () {
      if (this.activeMeasurement) {
        this.setReferenceMeasurement()
        this.getMeasurementEvents()
        this.getSignals()
      } else {
        this.resetValues()
      }
    },
    measurementComponents: {
      deep: true,
      handler () {
        let allSelected = this.measurementComponents.filter(function (m) {
          if (!m.active) return m
        })
        this.selectAllMeasurementComponents = (allSelected.length === 0)
      }
    },
    currentQueryMeasurementId (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.selectMeasurementFromProp(newVal)
      }
    }
  },
  methods: {
    setMeasurementIds: async function () {
      this.loading = true
      const newLength = this.selectedMeasurementIds.length
      var measurements = []
      if (newLength > 0) {
        for (const smid of this.selectedMeasurementIds) {
          let result = await smid
          let index = this.selectedMeasurements.findIndex(m => m.MeasurementId === result.id && m.RailObjectId === result.railObjectId)

          if (index === -1) {
            // Id not in selectedmeasurement set, fetch
            await measurementsApi.getMeasurement(result.railObjectId, result.id, false)
              .then(result => {
                let measurement = result.data
                measurement.ObjectName = smid.name || ''
                measurements.push(measurement)
              })
          } else {
            measurements.push(this.selectedMeasurements[index])
          }
        }
      }

      if (measurements.length > 0) {
        this.selectedMeasurements = measurements
      } else {
        this.selectedMeasurements = []
      }
      this.loading = false
    },
    checkIfOilDigital: function () {
      // SHOULD BE A UNIQUE ID, FOR NOW WE CAN USE THE CHART TITLE TO SEE IF NAME CONTAINS OIL
      if (this.chartTitle.toLowerCase().includes('oil')) {
        this.isOilMeasurement = true
      } else {
        this.isOilMeasurement = false
      }
    },
    async loadData () {
      this.loading = true
      this.checkIfOilDigital()
      this.measurementComponents.splice(0)
      if (this.isOilMeasurement) {
        this.loading = false
        return
      }

      if (this.switchObject.RailObjectId) {
        await AlarmService.GetSensorsByRailobjectId(this.switchObject.RailObjectId).then(result => {
          this.sensors = result.data
        })
      }
      this.setSensorData()
      if (Router.currentRoute.params.id !== this.currentId) {
        this.setLastMeasurementDate()
        this.currentId = Router.currentRoute.params.id
      }
      try {
        const result = await this.getMeasurements()
        if (!result) {
          return
        }
        this.allMeasurements = result.TriggeredMeasurements
        this.getTemperatures()
        const initialMeasurementId = this.currentQueryMeasurementId || this.measurementId
        await this.selectMeasurementFromProp(initialMeasurementId)
      } catch (error) {
        this.allMeasurements = []
        this.getLastMeasurement()
      } finally {
        this.loading = false
      }
    },
    setSensorData: function () {
      if (this.switchObject) {
        if (this.switchObject.UniqueId) {
          if (this.sensorData) {
            if (this.sensorData[0].ObjectIdUniqueId === this.switchObject.UniqueId) {
              this.sensorData[0].MeasurementComponent.forEach(mc => {
                if (mc.Discriminator === 'PointMotorComponent') {
                  this.chartMinY = mc.Sensor.RangeFrom
                  this.chartMaxY = mc.Sensor.RangeTo
                  this.yAxisTitle = mc.MeasureMode
                }
              })
            }
          }
        }
      }
    },
    async getChildMeasurements (MeasurementId) {
      let result = []
      // if parentId equals null, we might have childeren, lets get them
      // if parentId not equals null, we're already a child and it doesn't make sense to get the child of the child as we do not have these relations
      // this will save a couple of requests (with 404 as result) to the API. Note we might still see 404 errors due to measurements which are not there..
      if (this.switchObject.ParentRailObjectId === null) {
        await measurementsApi.getChildMeasurements(this.switchObject.RailObjectId, MeasurementId)
          .then(r => {
            result = r.data
          })
      }
      return result
    },
    setLastMeasurementDate () {
      if (this.switchObject) {
        const triggeredMeasurements = this.switchObject.MeasurementSet.TriggeredMeasurements
        const len = triggeredMeasurements.length
        if (len > 0) {
          const end = this.$options.filters.correctedMomentDate(triggeredMeasurements[len - 1].MeasurementDateTime)
          const start = moment(end).subtract(1, 'w')
          this.timeFrame = {
            start,
            end
          }
        }
      }
    },
    async getMeasurements () {
      if (this.switchObject) {
        const requestId = ++this.getMeasurementsRequestId
        let result
        this.changeTimeFrameGuard = moment(new Date())
        const dateFrom = moment(this.timeFrame.start).format('YYYY-MM-DD') + 'T00:00:00'
        const dateTo = moment(this.timeFrame.end).format('YYYY-MM-DD') + 'T23:59:59'
        await measurementsApi.getTimeLineRange(this.switchObject.RailObjectId, dateFrom, dateTo)
          .then(r => {
            result = r.data
          })

        if (requestId !== this.getMeasurementsRequestId) {
          return null
        }

        return result
      }
    },
    async getRefHistory () {
      let history = []
      if (this.switchObject) {
        await measurementsApi.getReferenceHistory(this.switchObject.RailObjectId)
          .then(r => {
            history = r.data
          })
      }
      this.refHistory = history
    },
    getTemperatures () {
      // TODO api call: get complex temperatures
    },
    getLastMeasurement () {
      if (this.allMeasurements && this.allMeasurements.length > 0) {
        const triggeredMeasurements = this.allMeasurements
        const last = triggeredMeasurements.length - 1
        this.addSelectedMeasurement(triggeredMeasurements[last].MeasurementId)
      } else {
        this.selectedMeasurementIds = []
      }
    },
    setReferenceMeasurement () {
      this.referenceMeasurement = this.activeMeasurement.ReferenceMeasurement
    },
    getMeasurementEvents () {
      if (this.activeMeasurement.AlarmMessages) {
        this.measurementEvents = this.activeMeasurement.AlarmMessages
      }
    },
    getSignals () {
      if (this.activeMeasurement.RelayMeasurements !== null) {
        this.digitalSignals = this.activeMeasurement.RelayMeasurements
        // PO-1979 ungrouped EventCodes need change to name otherwise we have duplicates. Not needed for one or two elements
        if (this.digitalSignals.length > 2) {
          for (var i = 0; i < this.digitalSignals.length; i++) {
            var ro = RailObjectService.getRailObjectByRailObjectId(this.digitalSignals[i].Events[0].RailObjectId)
            if (ro !== null && this.digitalSignals[i].EventCode.includes('_ANA2DIG')) {
              this.digitalSignals[i].EventCode = this.digitalSignals[i].EventCode.replace('_ANA2DIG', '') + ' ' + ro.Name
            }
          }
        }
      } else {
        this.digitalSignals = []
      }
    },
    resetValues () {
      this.referenceMeasurement = null
      this.measurementEvents = []
      this.digitalSignals = []
    },
    async addSelectedMeasurement (measurementId) {
      let selected = this.selectedMeasurementIds
      const railObjectId = this.switchObject.RailObjectId
      const measurement = this.allMeasurements.find(m => m.MeasurementId === measurementId)
      if (!measurement) {
        return
      }
      this.lastSelectedMeasurement = measurement
      const childMeasurements = await this.getChildMeasurements(measurementId)
      let children = []
      childMeasurements.forEach(cm => {
        children.push({
          railObjectId: cm.RailObjectId,
          name: cm.RailObject || '',
          id: cm.MeasurementId,
          dateTime: cm.MeasurementDateTime ? cm.MeasurementDateTime : 0
        })
      })
      if (selected.findIndex(s => s.id === measurementId && s.railObjectId === railObjectId) === -1) {
        selected.push({
          railObjectId: railObjectId,
          name: '',
          id: measurementId,
          dateTime: measurement.MeasurementDateTime ? measurement.MeasurementDateTime : 0,
          children: children
        })
      }
      children.forEach(c => {
        if (selected.findIndex(s => s.id === c.id && s.railObjectId === c.railObjectId) === -1) {
          selected.push({
            railObjectId: c.railObjectId,
            name: c.name || '',
            id: c.id,
            dateTime: c.dateTime,
            children: []
          })
        }
      })
      // Add available measurement components to list for individual graphs per component
      if (children.length > 0) {
        children.forEach(c => {
          var mea = this.measurementComponents.filter(m => m.id === c.railObjectId)
          if (mea.length === 0) {
            let sensor = this.sensors.filter(x => x.RailObjectId === c.railObjectId)
            if (sensor.length && sensor[0].ConfigSensor && sensor[0].ConfigSensor.UnitOfMeasure) {
              this.measurementComponents.push({ id: c.railObjectId, name: c.name, unitOfMeasure: sensor[0].ConfigSensor.UnitOfMeasure, active: true })
            } else {
              this.measurementComponents.push({ id: measurement.RailObjectId, name: this.switchObject.Name, unitOfMeasure: '-', active: true })
            }
          }
        })
      } else {
        var mea = this.measurementComponents.filter(m => m.id === measurement.RailObjectId)
        if (mea.length === 0) {
          let sensor = this.sensors.filter(x => x.RailObjectId === measurement.RailObjectId)
          if (sensor.length && sensor[0].ConfigSensor && sensor[0].ConfigSensor.UnitOfMeasure) {
            this.measurementComponents.push({ id: measurement.RailObjectId, name: this.switchObject.Name, unitOfMeasure: sensor[0].ConfigSensor.UnitOfMeasure, active: true })
          } else {
            this.measurementComponents.push({ id: measurement.RailObjectId, name: this.switchObject.Name, unitOfMeasure: '-', active: true })
          }
        }
      }
      this.measurementComponents = _.orderBy(this.measurementComponents, ['name'], ['asc'])
      this.selectedMeasurementIds = selected
    },
    removeSelectedMeasurement (measurementId) {
      let selected = this.selectedMeasurementIds
      const index = this.selectedMeasurementIds.findIndex(s => s.id === measurementId && s.railObjectId === this.switchObject.RailObjectId)
      if (index >= 0) {
        const children = this.selectedMeasurementIds[index].children
        selected.splice(index, 1)
        for (const child of children) {
          let cindex = this.selectedMeasurementIds.findIndex(s => s.id === child.id && s.railObjectId === child.railObjectId)
          selected.splice(cindex, 1)
        }
        this.selectedMeasurementIds = selected
        if (selected.length > 0) {
          this.lastSelectedMeasurement = selected[0]
        } else {
          this.lastSelectedMeasurement = this.activeMeasurement
        }
      }
    },
    resetSelectedMeasurements () {
      this.selectedMeasurementIds = []
    },
    changeActiveMeasurement (item) {
      this.activeMeasurement = item
      this.event = null
    },
    changeTimeFrame (timeFrame) {
      // PO-1341 ChangeTimeframe is triggered at load, while it is set with inital values
      // causing execution of the expensive API call getMeasurements, which is also called OnLoad()
      // ChangeTimeframe is also called twice with the pull down for fast time frame selection
      // checking on this.Loading didn't work
      // keeping a timestamp of the lastime getMeasurements was called and prevent in this function
      // the execution if it is called within 100 ms did the trick
      // not the nicest solution, but seems to work
      var now = moment(new Date())
      var d = moment.duration(now.diff(this.changeTimeFrameGuard))
      var ms = d.asMilliseconds()
      if (ms < 100) {
        return
      }

      this.timeFrame = timeFrame
      // clear all measurements, except selected
      this.getMeasurements()
        .then(r => {
          if (!r) {
            return
          }
          this.allMeasurements = r.TriggeredMeasurements
          if (this.selectedMeasurementIds.length === 0) {
            this.getLastMeasurement()
          }
        })
    },
    setMeasurementMax (max) {
      if (!max) {
        this.measurementMax = 0
      } else {
        this.measurementMax = max
      }
      this.setMax()
    },
    setDigitalMax (max) {
      if (!max) {
        this.digitalMax = 0
      } else {
        this.digitalMax = max
      }
      this.setMax()
    },
    setMax () {
      this.chartMaxX = Math.max(this.measurementMax, this.digitalMax) + 1.0
    },
    hoverMeasurement (item) {
      this.measurementHover = item
    },
    hoverSignal (item) {
      this.activeSignal = item
    },
    selectEvent (event) {
      this.event = event
    },
    selectAllMeasurementComponentsEvent () {
      if (!this.selectAllMeasurementComponents) {
        this.measurementComponents.forEach(c => {
          c.active = true
        })
      } else {
        this.measurementComponents.forEach(c => {
          c.active = false
        })
      }
      this.selectAllMeasurementComponents = !this.selectAllMeasurementComponents
    },
    async graphModeChanged () {
      this.graphMode = localStorage.graphMode
      await this.loadData()
    },
    onCommentAdded ({ measurementId, comment }) {
      // Update in allMeasurements, source for TimeSelector
      const i = this.allMeasurements.findIndex(m => m.MeasurementId === measurementId)
      if (i !== -1) {
        const updated = { ...this.allMeasurements[i], Comment: comment }
        this.allMeasurements.splice(i, 1, updated)
      }

      // Also update selectedMeasurements to make sure everything is in sync
      const j = this.selectedMeasurements.findIndex(m => m.MeasurementId === measurementId)
      if (j !== -1) {
        const updated = { ...this.selectedMeasurements[j], Comment: comment }
        this.selectedMeasurements.splice(j, 1, updated)
      }
    },
    async selectMeasurementFromProp (measurementIdOverride) {
      const measurementId = measurementIdOverride !== undefined ? measurementIdOverride : this.currentQueryMeasurementId || this.measurementId

      if (!measurementId || isNaN(measurementId)) {
        // No valid measurementId, falling back to last measurement
        this.selectedMeasurementIds = []
        this.getLastMeasurement()
        return
      }

      // Clear previous selections
      this.selectedMeasurementIds = []

      const measurement = this.allMeasurements.find(m => m.MeasurementId === measurementId)
      if (measurement) {
        await this.addSelectedMeasurement(measurementId)
      } else {
        // Fetch the measurement to get its date
        this.loading = true
        try {
          const response = await measurementsApi.getMeasurement(this.switchObject.RailObjectId, measurementId, false)
          const measurement = response.data
          if (measurement && measurement.MeasurementDateTime) {
            // Adjust timeFrame around the measurement date
            const measurementDate = this.$options.filters.correctedMomentDate(measurement.MeasurementDateTime)
            this.timeFrame = {
              start: moment(measurementDate).subtract(1, 'w'),
              end: moment(measurementDate).add(1, 'w')
            }
            // Reload allMeasurements with the new timeFrame
            const result = await this.getMeasurements()
            if (!result) {
              return
            }
            this.allMeasurements = result.TriggeredMeasurements
            // Add the measurement
            await this.addSelectedMeasurement(measurementId)
          } else {
            this.getLastMeasurement()
          }
        } catch (error) {
          this.getLastMeasurement()
        } finally {
          this.loading = false
        }
      }
    }
  },
  mounted () {
    if (localStorage.graphMode !== 'combined' &&
        localStorage.graphMode !== 'split') {
      localStorage.graphMode = 'combined'
    }
    this.graphMode = localStorage.graphMode
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/switch/SwitchEvents.vue